import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { useNavigate } from "react-router-dom";
import { countComments } from "services/apiService";
import dialogBgImage from "assets/images/dialogBgImage.png";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import SpinLoader from "components/SpinLoader";
import CloseIcon from "@mui/icons-material/Close";
import { postComment } from "services/apiService";

function CommentsDialog({ openStatus, onClose, postId, commentCount }) {
  let navigate = useNavigate();
  const [comment, setComment] = useState("");
  const [commentsData, setCommentsData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [isFetchMore, setIsFetchMore] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchCommentsCount();
  }, []);

  const fetchCommentsCount = async () => {
    const commentsDataRes = await countComments(postId, pageNumber);
    // console.log("commentsDataRes", commentsDataRes);
    setCommentsData(commentsDataRes);
    if (commentsDataRes.length > 1) {
      setIsFetchMore(true);
    }
    setPageNumber((prev) => prev + 1);
  };

  const handleNavigate = (value) => {
    navigate(`/profile/?username=${value}`);
  };

  const fetchMoreData = async () => {
    // console.log("done");
    const commentsDataRes = await countComments(postId, pageNumber);
    if (commentsDataRes.length < 1) {
      setIsFetchMore(false);
      return;
    }
    setIsFetchMore(true);
    setCommentsData(commentsData.concat(commentsDataRes));
    setPageNumber((prev) => prev + 1);
  };

  const handleInputChange = async (value) => {
    setComment(value);
  };

  const handlePostComment = async () => {
    if (comment === "") {
      // console.log("empty comment");
      // Swal.fire("Cannot post empty comment", "", "warning");
    }

    const postComData = {
      comment: comment,
      postID: postId,
    };

    const postComRes = await postComment(postComData);
    // console.log("postComRes", postComRes);
    setComment("");

    const commentsDataRes = await countComments(postId, 1);
    // console.log("commentsDataRes", commentsDataRes);
    setCommentsData(commentsDataRes);

    // setCommentsData([
    //   { text: comment, username: localStorage.userNameSingh },
    //   ...commentsData,
    // ]);
  };

  // console.log("NEWDATA", commentsData);

  return (
    <Dialog
      sx={{}}
      open={openStatus}
      maxWidth="sm"
      fullWidth
      fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <MDBox
        id="scrollableBox"
        sx={{
          height: isTabletOrMobile && "1000px",
          overflow: "auto",
          border: isDesktopOrLaptop && "1px solid #F2CB2E",
          borderRadius: isDesktopOrLaptop && "8px",
          backgroundColor: "#1a1a1a",
          // backgroundImage: `url(${dialogBgImage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // objectFit: "cover",
          // backgroundPosition: isTabletOrMobile && "bottom",
        }}
      >
        <DialogTitle sx={{}}>
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <MDBox>
              <MDTypography
                fontWeight="bold"
                color="singh"
                sx={{
                  textAlign: "center",
                  fontSize: isTabletOrMobile ? "15px" : "30px",
                  marginRight: isTabletOrMobile && "120px",
                  marginTop: isTabletOrMobile && "15px",
                }}
              >
                Comments {commentCount}
              </MDTypography>
            </MDBox>

            <IconButton onClick={onClose} color="white" fontSize="30px">
              <CloseIcon />
            </IconButton>
          </MDBox>
          <MDBox
            sx={{
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
              // paddingRight: "3rem",
              // paddingLeft: "3rem",
              // width: "80%",
            }}
          >
            <MDAvatar
              src="https://singhapp.infura-ipfs.io/ipfs/QmaXrq5pEcVEfwHaU7tJsAEKz7WXb68438JeSrN1SYe3GS"
              sx={{
                cursor: "pointer",
                // width: "2.5rem",
                // height: "2.5rem",
              }}
              imgProps={{
                style: { height: "100%", width: "100%" },
              }}
            />
            <TextField
              variant="standard"
              fullWidth
              multiline
              sx={
                {
                  // paddingLeft: "0px",
                  // border: "1px solid red",
                }
              }
              // InputLabelProps={{ shrink: false }}
              // label="...... Search here"
              placeholder="Add comment..."
              value={comment}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      disabled={comment === "" || !/\S/.test(comment)}
                    >
                      <MDTypography
                        sx={{
                          color:
                            comment === "" || !/\S/.test(comment) ? "grey" : "",
                          fontSize: "18px",
                        }}
                        onClick={() => handlePostComment()}
                      >
                        Post
                      </MDTypography>
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <InfiniteScroll
            scrollableTarget="scrollableBox"
            dataLength={commentsData.length}
            next={fetchMoreData}
            hasMore={isFetchMore}
            loader={
              <MDBox sx={{ textAlign: "center" }}>
                <SpinLoader />
              </MDBox>
            }
          >
            {commentsData.length > 0 ? (
              commentsData.map((item, idx) => (
                <MDBox
                  style={{
                    marginBottom: "20px",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                  onClick={() => handleNavigate(item.username)}
                >
                  <MDAvatar
                    src={item.pic}
                    imgProps={{ style: { height: "100%", width: "100%" } }}
                  />
                  <MDBox>
                    <MDTypography>{item.username}</MDTypography>
                    <MDTypography sx={{ fontSize: "15px", color: "#a2a2a2" }}>
                      {item.text}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              ))
            ) : (
              <MDBox sx={{ textAlign: "center", marginTop: "3rem" }}>
                <MDTypography color="text">No comments yet!</MDTypography>
              </MDBox>
            )}
          </InfiniteScroll>
        </DialogContent>
      </MDBox>
    </Dialog>
  );
}

export default CommentsDialog;
